import { GenericService } from '@/services/api/generic.service';
import { DomainUserType } from '@/custom/menicon/models';

export class DomainUserTypeService extends GenericService<DomainUserType> {
  constructor() {
    super('/menicon/v1/domain-user-types');
  }
}
